export const ROOT_FOLDER = { id: 0, name: "根目录", parentFolderId: null }; //用于显示面包屑
export const SYSTEM_USER_ID = -1; //系统用户id
// export { SYSTEM_USER_ID };
